import { type FC } from 'react'
import { Alert, AlertType, Button } from '@egw/components'
import { WEALTH_ROUTES } from '@egw/constants'
import { useTranslation } from '@egw/i18n'
import { useRouter } from '@egw/router'
import { Layout, PageHeader } from '../../components'

export const PasskeyRecoveryPage: FC = () => {
  const { t } = useTranslation('features-auth')
  const { navigate } = useRouter()

  return (
    <Layout>
      <PageHeader title={t('recovery.title')} backLinkUrl={WEALTH_ROUTES.RECOVERY.backPath} />
      <p className="pb-4">{t('recovery.recover_intro')}</p>
      <p className="pt-2 font-medium text-sm">{t('recovery.intro_step_1_label')}</p>
      <p className="pb-2">{t('recovery.intro_step_1')}</p>
      <p className="pt-2 font-medium text-sm">{t('recovery.intro_step_2_label')}</p>
      <p className="pb-xs">{t('recovery.intro_step_2')}</p>
      <div className="flex-1 md:hidden" />
      <Alert alertType={AlertType.Warning} description={t('recovery.warning')} className="mt-1 mb-6" />
      <Button
        className="w-full md:w-min"
        testId="sendTextOtp"
        onClick={() => {
          navigate(WEALTH_ROUTES.RECOVERY_METHOD.path)
        }}
      >
        {t('recovery.continue')}
      </Button>
    </Layout>
  )
}
